import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminRegister.css';
import { API_BASE_URL } from '../config/apiConfig';

function AdminRegister() {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    mobile: '',
    password: '',
    confirmPassword: ''
  });

  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setMessage('');
  }, [formData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleRegister = async (e) => {
    e.preventDefault();

    const { username, email, mobile, password, confirmPassword } = formData;

    if (password !== confirmPassword) {
      setMessage('❌ Passwords do not match');
      return;
    }

    if (password.length < 6) {
      setMessage('❌ Password must be at least 6 characters');
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(`${API_BASE_URL}/api/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, email, mobile, password })
      });

      const data = await res.json();

      if (res.ok) {
        setMessage('✅ Registration successful! Redirecting to login...');
        setTimeout(() => navigate('/admin/login'), 1500);
      } else {
        setMessage(data.message || 'Registration failed');
      }
    } catch {
      setMessage('Network error: Unable to reach server');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="register-form" onSubmit={handleRegister}>
      <h2>🔑 Admin Registration</h2>

      <input
        type="text"
        name="username"
        value={formData.username}
        onChange={handleChange}
        placeholder="Username"
        required
      />
      <input
        type="email"
        name="email"
        value={formData.email}
        onChange={handleChange}
        placeholder="Email ID"
        required
      />
      <input
        type="tel"
        name="mobile"
        value={formData.mobile}
        onChange={handleChange}
        placeholder="Mobile Number"
        pattern="[0-9]{10}"
        required
      />
      <input
        type="password"
        name="password"
        value={formData.password}
        onChange={handleChange}
        placeholder="Password"
        required
      />
      <input
        type="password"
        name="confirmPassword"
        value={formData.confirmPassword}
        onChange={handleChange}
        placeholder="Confirm Password"
        required
      />

      <button type="submit" disabled={loading}>
        {loading ? 'Registering...' : 'Register'}
      </button>

      {message && <p className="register-message">{message}</p>}
    </form>
  );
}

export default AdminRegister;
